// extracted by mini-css-extract-plugin
module.exports = {"root":"shareturn_root_3Tsn3"};